<template>
  <section class="block-brands gb-section" v-if="brands">
    <div class="block-brands-wrapper gb-wrapper mb-20">
      <h2 class="mb-20 tx-uppercase" data-aos="zoom-in-down" v-if="brands.title">{{ brands.title }}</h2>
      <p class="mb-20" data-aos="zoom-in-down" v-if="brands.description" v-html="brands.description"></p>
    </div>
    <div class="block-brands-wrapper gb-wrapper mt-20" v-if="brands.items">
      <UltraCarousel :items-to-show="4" :autoplay="3000" :slides="brands.items" />
    </div>
  </section>
</template>

<script>
import UltraCarousel from "@/components/UltraCarousel.vue";

export default {
  name: "BlockBrands",
  components: {UltraCarousel},
  computed: {
    brands() {
      return this.$store.getters['brands'];
    },
  },
}
</script>

<style scoped>
.block-brands {
  color: gray;
  background-image: linear-gradient(45deg, white, lightgray);
  padding: 120px 0;
}
.block-brands-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

@media only screen and (max-width: 600px) {
  .block-brands-wrapper {
    flex-direction: column;
  }
  .block-brands-wrapper {
    text-align: center;
  }
}
</style>
